import { useEffect } from 'react'

// Lets the freshly mounted sections lay out before a deep link such as
// /#contact, /kurumsal#kalite or /serigrafi#contact scrolls to its target.
const HASH_SCROLL_DELAY_MS = 100

/**
 * Scroll to the URL hash target once after mount. `behavior: 'auto'` follows
 * the root's CSS scroll-behavior: smooth by default, instant under
 * prefers-reduced-motion. Shared by the home, service and corporate pages.
 */
export default function useHashScrollOnLoad() {
  useEffect(() => {
    const raw = window.location.hash.slice(1)
    let id = raw
    try {
      id = decodeURIComponent(raw)
    } catch {
      // A malformed escape (e.g. "#100%") is not a section id; keep it raw.
    }
    if (!id) return undefined
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'auto' })
    }, HASH_SCROLL_DELAY_MS)
    return () => clearTimeout(timer)
  }, [])
}
